import { Box, Link, ScreenReaderOnly, TextBody } from '@ally/metronome-ui'
import React, { FC } from 'react'
import { AccountDetails } from '../../types'
import { useLinkType } from '../hooks'
import { maskCardNumber } from '../utils/maskCardNumber'

export const OrderCard: FC = () => (
  <Box>
    <TextBody size="sm" weight="bold" tag="span">
      Debit Card:{' '}
    </TextBody>
    <Link to="/payments/debit-card/order-card" text="Order Now" />
  </Box>
)

interface ManageCardProps {
  lastFourDigits: string
  custCardId: string
}

export const ManageCard: FC<ManageCardProps> = ({
  lastFourDigits,
  custCardId,
}) => {
  const maskedCardNumber = maskCardNumber(lastFourDigits)
  return (
    <Box>
      <TextBody aria-hidden size="sm" weight="bold" tag="span">
        Debit Card: {maskedCardNumber}{' '}
      </TextBody>
      <ScreenReaderOnly>{`Card ending in ${maskedCardNumber}`}</ScreenReaderOnly>
      <Link
        to={`/payments/debit-card/manage-card/${custCardId}`}
        text="Manage"
      />
    </Box>
  )
}

interface DebitCardLinkProps {
  account: AccountDetails
}

export const DebitCardLink: FC<DebitCardLinkProps> = ({
  account: { accountIndex, accountType },
}) => {
  const linkType = useLinkType({ accountType, accountId: accountIndex })

  switch (linkType.tag) {
    case 'order':
      return <OrderCard />
    case 'manage': {
      const { lastFourDigits, custCardId } = linkType

      return (
        <ManageCard lastFourDigits={lastFourDigits} custCardId={custCardId} />
      )
    }
    case 'none':
    default:
      return <></>
  }
}
